export const API_MONTHLY_OPNED_TRADE_SUCCESS = "API_MONTHLY_OPNED_TRADE_SUCCESS";
export const API_MONTHLY_OPNED_TRADE_FAIL ="API_MONTHLY_OPNED_TRADE_FAIL";
export const GET_MONTHLY_OPNED_TRADE_LIST = "GET_MONTHLY_OPNED_TRADE_LIST";